import React from 'react';
import {
  FaFacebook,
  FaInstagram,
  FaTiktok,
  FaXTwitter,
  FaYoutube,
} from 'react-icons/fa6';

const Hero: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="home" className="section hero">
      <div className="wrapper">
        <div className="hero__inner">
          <div className="stack">
            <span className="eyebrow">Author of Literary Fiction</span>
            <h1 className="hero__title">Aarjay S</h1>
            <p className="hero__lead">
              I write fiction that reaches into the marrow of human connection—love,
              friendship, kinship, and every fragile bond that shapes us. My stories
              unravel the delicate threads that bind us together, exposing both
              tenderness and fracture, the quiet rebellions against the world&apos;s
              rigid orthodoxies. If my words sting with rawness, it is because they
              carry fragments of our collective hunger—for truth, for belonging,
              for intimacy, for freedom, and for something greater than ourselves.
            </p>

            <div className="btn-row">
              <button
                type="button"
                className="btn btn--primary"
                onClick={() => scrollToSection('contact')}
              >
                Connect with Me
              </button>
              <button
                type="button"
                className="btn btn--ghost"
                onClick={() => scrollToSection('books')}
              >
                Explore the Book
              </button>
            </div>

            <div className="hero__meta">
              <span className="badge">A substantial share of the royalties will be donated to organizations supporting mental health initiatives</span>
              <span className="text-subtle">Based in the U.S. · Fiction on human connection</span>
            </div>

            <div className="social-list">
              <a
                href="https://www.instagram.com/aarjay__s/"
                target="_blank"
                rel="noopener noreferrer"
                className="icon-button"
                aria-label="Instagram"
              >
                {React.createElement(FaInstagram as React.ComponentType)}
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61581285654908"
                target="_blank"
                rel="noopener noreferrer"
                className="icon-button"
                aria-label="Facebook"
              >
                {React.createElement(FaFacebook as React.ComponentType)}
              </a>
              <a
                href="https://www.youtube.com/@Aarjay_S"
                target="_blank"
                rel="noopener noreferrer"
                className="icon-button"
                aria-label="YouTube"
              >
                {React.createElement(FaYoutube as React.ComponentType)}
              </a>
              <a
                href="https://x.com/Aarjay__S"
                target="_blank"
                rel="noopener noreferrer"
                className="icon-button"
                aria-label="X"
              >
                {React.createElement(FaXTwitter as React.ComponentType)}
              </a>
              <a
                href="https://www.tiktok.com/@aarjay_s"
                target="_blank"
                rel="noopener noreferrer"
                className="icon-button"
                aria-label="TikTok"
              >
                {React.createElement(FaTiktok as React.ComponentType)}
              </a>
            </div>
          </div>

          <div className="surface">
            <div className="book-card">
              <div className="media-frame">
                <img
                  src="/book-cover.png"
                  alt="The Arid Lips — After the Last Kiss"
                  className="media media--framed"
                  style={{ maxWidth: '260px' }}
                />
              </div>
              <div className="stack">
                <div>
                  <p className="eyebrow" style={{ marginBottom: '0.75rem' }}>
                    Available Now
                  </p>
                  <h2 className="headline" style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>
                    The Arid Lips
                  </h2>
                  <p className="text-muted" style={{ margin: 0 }}>
                    After the Last Kiss
                  </p>
                </div>
                <p className="text-muted" style={{ marginBottom: '0.5rem' }}>
                  “Some hearts break quietly—hers broke without a word.”
                </p>
                <div className="divider" />
                <p className="text-muted" style={{ marginBottom: 0 }}>
                  A substantial share of the royalties will be donated to organizations supporting
                  mental health initiatives.
                </p>
                <div className="purchase-links">
                  <a
                    className="purchase-link"
                    href="https://www.amazon.com/dp/B0FD369KK8"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Amazon US <span>&rarr;</span>
                  </a>
                  <a
                    className="purchase-link"
                    href="https://www.amazon.co.uk/dp/B0FD369KK8?ref=cm_sw_r_ffobk_cp_ud_dp_X3SMG8X35QHYW1DRZ438&social_share=cm_sw_r_ffobk_cp_ud_dp_X3SMG8X35QHYW1DRZ438&bestFormat=true"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Amazon UK <span>&rarr;</span>
                  </a>
                  <a
                    className="purchase-link"
                    href="https://www.amazon.in/dp/B0FD369KK8"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Amazon India <span>&rarr;</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

